import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { Box } from '@mui/material'
import {
  Area,
  AreaChart,
  CartesianGrid,
  Line,
  LineChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

import { useGET_dashboardAttendanceQuery } from 'redux/api/dashboardApi'
import { RootState } from 'redux/store'

import { PRIMARY_BLUE } from 'utils/customizedTheme'
import BoxTitle from 'components/atoms/BoxTitle'
import { HowToReg } from '@mui/icons-material'

interface IProps{
  student?: number
}

const Attendance: FC<IProps> = ({student}) => {
  const { t } = useTranslation()
  const reduxKey = 'dashboard'

  const filters = {}
  const date_after=useSelector((state: RootState) => state[reduxKey].date_after)
  const date_before=useSelector((state: RootState) => state[reduxKey].date_before)

  if(student)filters["student"]=student
  if(date_after)filters["start_date_after"]=date_after
  if(date_before)filters["start_date_before"]=date_before

  const { data } = useGET_dashboardAttendanceQuery(filters)


  return (
    <Box className="thick-border" sx={{ height: '350px' }}> { data && <>
      <BoxTitle title={t('common.attendance')} icon={<HowToReg />} />
      <div style={{ height: '20px' }} />
      <ResponsiveContainer width='100%' height='90%'>
        <AreaChart
          data={data.slice(-6)}
          margin={{
            bottom: 20,
            right: 20
          }}
        >
          <XAxis dataKey='month' interval={0} tick={<CustomizedAxisTick />} />
          <YAxis />
          <Tooltip />
          <ReferenceLine y={100} />
          <Area
            type='monotone'
            dataKey='avg_percentage'
            fill={PRIMARY_BLUE}
            activeDot={{ r: 2 }}
            label={<CustomizedLabel />}
          />
        </AreaChart>
      </ResponsiveContainer>
    </> }</Box>
  )
}

export default Attendance

export const CustomizedLabel = (props) => {
  const { x, y, stroke, value } = props

  return (
    <text x={x} y={y} dy={-4} fill={stroke} fontSize={10} textAnchor='middle'>
      {`${value} %`}
    </text>
  )
}
export const CustomizedAxisTick = (props) => {
  const { x, y, payload } = props

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} fontSize={10} textAnchor='end' fill='#666' transform='rotate(-35)'>
        {payload.value}
      </text>
    </g>
  )
}
